import React, { FC } from 'react'
import { IonHeader } from '@ionic/react'
import { observer } from 'mobx-react'
import './index.scss'

interface IProps {
  info?: any;
  onClick: () => void;
}

const UseHeader: FC<IProps> = ({ onClick, info }: IProps) => {
  return (
    <div
      data-cypid='mmgMarketItem'
      className={`market-detail-tab ${!info ? 'auto-width' : ''}`}
      onClick={() => onClick()}
    >
      {info && (
        <div
          className='left-con'
          dangerouslySetInnerHTML={{
            __html: info,
          }}
        >
        </div>
      )}
      <div className='detail-area'>
        <span>{i18n.t('mkt.market.marketDetail')}</span>
        <i className='iconfont icon-chevron-right'></i>
      </div>
    </div>
  )
}

export default observer(UseHeader)
